module.exports = __webpack_public_path__ + "assets/thumb-emergency@2x.f1fe225a.png";